// The three work scopes the KJP summary covers, with the display label and
// measurement unit each one carries (INFS-1454).
//
// Sibling to titles.js / colors.js / columns.js rather than folded into any of
// them, for the same reason they are siblings of each other: this is the
// scope's *identity* (its code, its human name, the unit its quantities are
// in), not the workbook's table heading, fill colour or column layout.
//
// These labels used to live in KjpControls.vue's `scopes` array, which existed
// only to render the work-scope checkboxes. INFS-1454 removed that control —
// every Apply now generates all three scopes — so the labels moved here, where
// the tab strip and the utilisation tiles can both read them. Two components
// inlining the same three strings is exactly the drift this directory's other
// data modules exist to prevent.
//
// `unit` is the unit of the scope's *quota and usage* quantities, i.e. what
// annualQuota() in src/kjp.js returns: m² of patched or marked area for R01
// and R06, km of shoulder length for R02. It is not the endpoint's own `unit`
// field (which is "m" for R02 and scaled down in bucketUsage) — that one
// describes the API payload, this one describes the figure a reader sees.
export const KJP_SCOPES = [
  { code: 'R01', name: 'Pavement', unit: 'm²' },
  { code: 'R02', name: 'Road Shoulder', unit: 'km' },
  { code: 'R06', name: 'Road Line Marking', unit: 'm²' },
]

// Every scope code, in workbook order. The order is load-bearing: the inner
// tab strip and the tile row both render in it, and KjpSummary keeps the
// user's active tab by code, so a reordering here reorders the UI.
export const KJP_SCOPE_CODES = KJP_SCOPES.map((s) => s.code)

const BY_CODE = KJP_SCOPES.reduce((acc, s) => {
  acc[s.code] = s

  return acc
}, {})

export function scopeMeta(code) {
  return BY_CODE[code] || null
}

// "R01 — Pavement". An em dash, not a hyphen: these sit in a tab strip beside
// each other and the wider separator is what keeps the code readable as a
// distinct token rather than reading as part of the name.
export function scopeLabel(code) {
  const meta = BY_CODE[code]

  return meta ? `${meta.code} — ${meta.name}` : code
}

export function scopeUnit(code) {
  const meta = BY_CODE[code]

  return meta ? meta.unit : ''
}
